document.addEventListener("DOMContentLoaded", function () {
	let id = ".mm-splide-video-onglets";
	let splideElem = document.querySelector(id);

  if (splideElem) {
    new Splide(splideElem, {
		type: "slide",
		arrows: true,
		pagination: false,
		gap: 10,
		perPage: 2,
		padding: {
			right: "15rem",
		},
		breakpoints: {
			768: {
				perPage: 1,
				padding: {
					right: '25vw',
				},
			},
		},
	}).mount();
  }
});

const sectionContent = document.querySelector('.mm-vo-content-container')
if (sectionContent) {
  const ongletsTitleAll = sectionContent.querySelectorAll(".mm-vo-onglets-title");
  const ongletsContentAll = sectionContent.querySelectorAll('.mm-vo-content');

  if (ongletsTitleAll) {
    ongletsTitleAll.forEach(ongletTitle => {
      ongletTitle.addEventListener('click', function () {
        const indexOnglet = ongletTitle.dataset.index;
        const contentActive = `mm-vo-content-${indexOnglet}`
        ongletsContentAll.forEach(ongletContent => {
          if (ongletContent.classList.contains(contentActive)) {
            ongletContent.classList.add('active');
          } else {
            ongletContent.classList.remove('active');
          }
        });

        const ongletActiveOld = sectionContent.querySelector(".mm-vo-onglets-title.active");
        if (ongletActiveOld != ongletTitle) {
          ongletActiveOld.classList.remove('active')
          ongletTitle.classList.add('active')
        }
      });
    });
  }
}
